<template>
    <div class="editor">
        <div class="content-wrapper">
            <div class="mb-2">
                <div v-if="error" class="alert alert-danger my-2" role="alert">
                    {{ lang['group.group_name_prompt'] }}
                </div>
                <label for="group-name" class="section-heading">{{ lang['group.group_name'] }}</label>
                <input id="group-name" class="form-control" type="text" v-model="group.name" @keyup="resetError">
            </div>
            <div class="mb-2">
                <div id="add_module_header" class="d-flex justify-content-between align-items-center mt-2 mb-1">
                    <label for="modules" class="seciont-heading">Learning Module</label>
                    <div class="new-problem" @click="openModuleModal(false)">{{group.module_id ? 'Change Module' : 'Add Module'}} <i class="fas fa-plus-circle ml-1"></i></div>
                </div>

                <div v-if="group.module_id && group.module_id > 0">
                    <div class="problem-card" @click="openModuleModal(true)">
                        {{ groupModule.name }}
                    </div>
                </div>
            </div>

            <label class="section-heading">{{ lang['group.decisions'] }}</label>

            <div v-if="!decisionsLoaded" class="mt-4 flex-r flex-center" style="font-size: 1.25em;">
                <div><i class="far fa-spinner fa-spin mr-2 blue"></i> {{ lang['general.loading'] }}</div>
            </div>
            <div v-else>
                <div v-if="decisions.length == 0" class="prompt">{{ lang['group.select_group_instructions'] }}</div>
                <div v-for="(decision, index) in decisions" class="problem-card">
                    <div class="problem-text">{{decision.text}}</div>
                    <div class="ml-auto my-auto">
                        <i class="fal fa-times" @click="removeDecision(index, decision.id)"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['content', 'model'],
    data() {
        return {
            decisions: [],
            error: false,
            group: {},
            usedDecisions: [],
            modelDecisions: [],
            decisionsLoaded: false,
            mode: "",
            groupModule: {},
            lang: lang,
        }
    },

    mounted() {
        $(".editorButton").addClass("hidden");
        this.mode = actionMode;
        $.get('/problemgroups/' + this.model + '/decisions',
        res => {
            this.modelDecisions = res.decisions;
            this.usedDecisions = res.used_decisions;
            $('.nodeTerminal').addClass('mapHighlightGold');
            this.usedDecisions.forEach(id => {
                $('.n' + id + '.nodeTerminal').removeClass('mapHighlightGold');
            });
        }).catch((error) => {
            bus.$emit('popupError', error);
        });
        if(this.content.id) {
            this.group = this.content;
            $.get('/problemgroups/' + this.group.model_id + '/group/' + this.group.id,
            res => {
                this.decisionsLoaded = true;
                this.decisions = res.decisions;
                if(res.module != null) {
                    this.groupModule = res.module;
                }
                res.decisions.forEach(decision => {
                    if(decision) {
                        $('.n' + decision.id).addClass('mapHighlightNode');
                    }
                });
            });
        }
        else {
            this.decisionsLoaded = true;
        }
        // actionMode = "defineGroup";
        defineGroup = true;
    },

    methods: {
        addPath(id) {
            const used = this.usedDecisions.find(decision => {
                return decision == id;
            });
            if(!used) {
                $.get('/problemgroups/'+ this.model + '/decision/' + id,
                res => {
                    const exists = this.decisions.find(decision => {
                        return decision.id == res.id;
                    })
                    if(!exists) {
                        this.decisions.push(res);
                        $('.n' + id + '.nodeTerminal').removeClass('mapHighlightGold')
                        $('.n' + id + '.nodeTerminal').addClass('mapHighlightNode')
                    }
                }).catch((error) => {
                    bus.$emit('popupError', error);
                });
            }
        },

        addModule(groupModule, prompt) {
            this.group.module_id = groupModule.id;
            this.groupModule = groupModule;
            this.$forceUpdate();
        },

        openModuleModal(edit) {
            const data = {
                groupID: edit ? this.group.id : 0,
                modelID: this.model,
                name: edit ? this.groupModule.name : "",
                link: edit ? this.groupModule.link : "",
                type: 'group'
            }
            bus.$emit('openModal', 'module', data);
        },

        removeDecision(index, id) {
            this.decisions.splice(index, 1);
            this.usedDecisions = this.usedDecisions.filter(item => item != id);
            $('.n' + id + '.nodeTerminal').removeClass('mapHighlightNode');
            $('.n' + id + '.nodeTerminal').addClass('mapHighlightGold');
        },

        resetError() {
            this.error = false;
        },

        isURL(str) {
            if(!str) {
                return true;
            }
            try {
                new URL(str);
                return true;
            } catch (_) {
                return false;
            }
        },

        save() {
            const name = this.group.name;
            this.error = !name || !name.trim().length > 0;
            if(!this.error) {
                var decision_ids = [];
                this.decisions.forEach(decision => {
                    decision_ids.push(decision.id);
                });
                $.post('/problemgroups/' + this.model + '/save', {
                    id: this.group.id || null,
					name: this.group.name,
                    language: this.group.language || 'English',
                    decision_ids,
                    module_id: this.group.module_id || null,
                },
                res => {
                    if(!res.error) {
                        this.$emit('close');
                        defineGroup = false;
					}
				}).catch((error) => {
                    bus.$emit('popupError', error);
                });
            }
        },

    },

    created() {
        bus.$on('save', this.save);
        bus.$on('addPath', this.addPath);
        bus.$on('groupModule', this.addModule);
	},

	beforeDestroy() {
        bus.$off('save', this.save);
        bus.$off('addPath', this.addPath);
        bus.$off('groupModule', this.addModule);
        $('.nodeTerminal').removeClass('mapHighlightGold');
        $('.nodeTerminal').removeClass('mapHighlightNode');
        // actionMode = this.mode;
        defineGroup = false;
	}
}

</script>
